import FormatCurrency from 'components/Common/FormatCurrency'
import Pill from 'components/Luxkit/Pill'
import Caption from 'components/Luxkit/Typography/Caption'
import Group from 'components/utils/Group'
import { EXPERIENCE_MINIMUM_DISCOUNT_PERCENTAGE_TO_SHOW } from 'constants/experience'
import React from 'react'
import TextButton from 'components/Luxkit/Button/TextButton'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import { rem } from 'polished'
import styled from 'styled-components'
import PriceRowPriceCaption from 'components/Luxkit/PricePoints/PriceRowPriceCaption'
import PriceRowPrice from 'components/Luxkit/PricePoints/PriceRowPrice'

const ValueWrapper = styled(Caption)`
  display: flex;
  gap: ${rem(4)};
  flex-wrap: wrap;
  align-items: center;
`

interface Props {
  experience: App.ExperienceBookingView
}

export function ExperienceOfferPriceDetails({ experience }: Props) {
  return (
    <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="end">
      <Group direction="vertical" verticalAlign="end">
        <PriceRowPriceCaption>From</PriceRowPriceCaption>
        <PriceRowPrice
          size="L"
          price={experience.price}
          saleUnit={experience.ticketUnitLabel ?? 'total'}
          taxesAndFees="inclusive"
        />
        {experience.discount >= EXPERIENCE_MINIMUM_DISCOUNT_PERCENTAGE_TO_SHOW && (
          <ValueWrapper variant="large" weight="bold" colour="neutral-one">
            Valued up to <FormatCurrency value={Math.ceil(experience.grossPrice)} />
            <Pill kind="primary" variant="success">-{experience.discount}%</Pill>
          </ValueWrapper>
        )}
      </Group>
      <CSSBreakpoint min="desktop">
        <TextButton kind="primary" nonInteractable>
          View
        </TextButton>
      </CSSBreakpoint>
    </Group>
  )
}
